/* eslint-disable react-hooks/exhaustive-deps */
import React, { createRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal as RBModal } from "react-bootstrap";
import Menu from "../menu";
import {
    Table,
    Pagination,
    Button,
    Input,
    Select,
    CheckBox,
    Icon,
    DatePicker,
    Modal,
    SelectActions,
} from "../../components";
import { axios, Constants, Globals, ENV, Colors } from "../../utils";
import { Warehouse, Category, Brand, Payment } from "../../services";
import NumberFormat from "react-number-format";
import PrinterIcon from '../../assets/icons/printer.png';
import CloseBlackIcon from '../../assets/icons/close-black.png';
import CloseIcon from "../../assets/icons/icono_cerrar.png";
import FilterIcon from "../../assets/icons/icono_filtro.png";
import ConsolidadtedIcon from '../../assets/icons/consolidaded.png';
import IndividualIcon from '../../assets/icons/individual.png';
import ExcelIcon from '../../assets/icons/excel-file.png';
import UploadIcon from '../../assets/icons/upload-excel-desktop.png';
import CheckIcon from '../../assets/icons/check.png';
import ErrorIcon from '../../assets/icons/cancel.png';
import DownloadIcon from '../../assets/icons/download.png';
import moment from "moment";
import CreatePayment from "./create-payment";

const TAB = {
    CONSOLIDATED: 1,
    INDIVIDUAL: 2,
    IMPORT: 3,
}

class Payments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: TAB.CONSOLIDATED,
            thead: [],
            trows: [],
            total: 0,
            header: [
                {
                    value: "id",
                    label: "ID",
                    type: 1,
                    section: "required",
                    order: 0
                },
                {
                    value: "created_at",
                    label: "Fecha Emisión",
                    type: 1,
                    section: "required",
                    order: 0
                },
                {
                    value: "dispatch_date",
                    label: "Fecha Despacho",
                    type: 1,
                    section: "required",
                    order: 0
                },
                {
                    value: "seller",
                    label: "Vendedor",
                    type: 1,
                    section: "required",
                    order: 1
                },
                {
                    value: "client",
                    label: "Cliente",
                    type: 1,
                    section: "required",
                    order: 2
                },
                {
                    value: "status",
                    label: "Estatus\nPago",
                    type: 1,
                    section: "required",
                    order: 3
                },
                {
                    value: "amount",
                    label: "Total\nDeuda",
                    type: 1,
                    section: "required",
                    order: 3
                },
                {
                    value: "to_pay",
                    label: "Total\nPor Cobrar",
                    type: 1,
                    section: "required",
                    order: 4
                },
                // {
                //   value: "branch",
                //   label: "Sucursal",
                //   type: 1,
                //   section: "required",
                //   order: 5
                // },
                // {
                //   value: "warehouse",
                //   label: "Almacen",
                //   type: 1,
                //   section: "required",
                //   order: 6
                // },
                // {
                //   value: "payment_method",
                //   label: "Método de pago",
                //   type: 1,
                //   section: "required",
                //   order: 6
                // },
                // {
                //   value: "",
                //   label: "Acciones",
                //   type: 1,
                //   section: "required",
                //   order: 7
                // },
            ],
            optionals: [
                { value: "code", label: "Código", show: true },
                { value: "name", label: "Nombre", show: true },
                { value: "branch", label: "Almacen", show: true },
                { value: "warehouse", label: "Almacen", show: true },
                { value: "current_stock", label: "Existencia", show: true },
                //{ value: "committed", label: "Comprometido", show: false },
                { value: "available", label: "Disponible", show: true },
                { value: "total", label: "Total", show: true },
                //{ value: "cost", label: "Costo", show: false },
                //{ value: "price", label: "Precio Min.", show: false },
                //{ value: "price_max", label: "Precio Max.", show: false },
                //{ value: "price_offer", label: "Precio Oferta", show: false }
            ],
            page: 1,
            last_page: 1,
            data: [],
            branches: [],
            warehouses: [],
            user: null,
            providers: {},
            form: {
                status: "",
                search: "",
                branch_id: "",
                warehouse_id: "",
                category_id: "",
                subcategory_id: "",
                brand_id: "",
                model_id: "",
                user_id: this.props.user.id,
                code: true,
                order_id: "",
                name: true,
                current_stock: true,
                total: false,
                price: false,
                price_max: false,
                price_offer: false,
                cost: false,
                committed: false,
                available: false,
                since: "", //moment().toDate(),
                until: "", //moment().toDate(),
                payment_method_id: "",
                client_id: "",
                seller_id: "",
                zone_id: "",
                currency: Constants.CURRENCIES.DOLARES,
                is_expired: "",
                odoo_division_id: "",
            },
            categories: [],
            subcategories: [],
            brands: [],
            models: [],
            payment_methods: [],
            clients: [],
            sellers: [],
            paymentMethods: [],
            zones: [],
            odoo_divisions: [],
            countPrice: 0,
            user_id:
                this.props.user.role === 4
                    ? this.props.user.enterprise_users.enterprise_id
                    : this.props.user.id,
            role: this.props.user.role,
            showProductsFilters: true,
            dates: {
                minDate: "",
                maxDate: ""
            },
            total_pedidos: 0,
            total_abonado: 0,
            total_cobrar: 0,
            modalPaymentDetails: false,
            modalAddPayment: false,
            modalAddPaymentMultiple: false,
            selectedItem: null,
            dataClients: [],
            showPhoto: null,
            showFilters: false,
            status_payments: [
                { label: 'Por aprobar', value: 3 },
                { label: 'Vencida', value: 1 },
                { label: 'Próximo a vencer', value: 2 },
                { label: 'Pagada', value: 4 },
            ],
            importSummary: {
                processed: 0,
                errors: 0,
                total: 0
            },
            fileToUpload: null,
            collapsedClients: {},
            isDragging: false,
        };
    }

    abortController = new AbortController();
    debounce = createRef();

    handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            this.setState({ isDragging: true });
        } else if (e.type === "dragleave") {
            this.setState({ isDragging: false });
        }
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const ev = { target: { files: e.dataTransfer.files } };
            this.chooseFileCxC(ev);
        }
    };

    toggleClient = (clientId) => {
        this.setState(prevState => ({
            collapsedClients: {
                ...prevState.collapsedClients,
                [clientId]: !prevState.collapsedClients[clientId]
            }
        }));
    }

    componentDidMount() {
        this.load();
        this.getThead();
        this.getClients();
        this.getPaymentMethods();
        this.getSellers();
        const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
        if (isOdooUser) {
            this.getOdooDivisions();
        }
    }
    // componentDidUpdate(_, prevState) {
    //   if (prevState.form.branch_id !== this.state.form.branch_id && this.state.form.branch_id) {
    //     this.getWarehouses();
    //     this.load();
    //   }
    // }
    componentWillUnmount() {
        this.abortController.abort();
    }

    load = async (page = 1) => {
        this.state.tab === TAB.CONSOLIDATED
            ? this.getConsolidated(page)
            : this.getIndividual(page);
    };

    getIndividual = (resetPage = null) => {
        let { page, form } = this.state;

        if (typeof resetPage === "number") {
            page = resetPage;
        }

        form.page = page;
        form.user_id = this.props.user.id;
        form.web = true
        form.withoutUsers = true

        axios
            .post("admin/reports/accounts-receivable?page=" + page, form)
            .then(res => {
                this.setState({
                    page,
                    last_page: res.data.orders.last_page,
                    data: res.data.orders.data,
                    total_pedidos: res.data.total,
                    total_abonado: res.data.total_paid,
                    total_cobrar: res.data.total_to_pay,
                });
            })
            .catch(err => {
                Globals.showError();
            });
    };

    getConsolidated = (resetPage = null) => {
        let { page, form } = this.state;

        if (typeof resetPage === "number") {
            page = resetPage;
        }

        form.page = page;
        form.user_id = this.props.user.id;
        form.web = true;

        axios
            .post("admin/accounts-receivable/consolidated?page=" + page, form)
            .then(res => {

                const dataClients = new Set();
                res.data.clients.data.map(x => dataClients.add(x.id));

                this.setState({
                    page,
                    last_page: res.data.clients.last_page,
                    data: res.data.clients.data,
                    total_pedidos: res.data.total,
                    total_abonado: res.data.total_paid,
                    total_cobrar: res.data.total_to_pay,
                    dataClients: [...dataClients],
                });
            })
            .catch(err => {
                Globals.showError();
            });
    };

    getPaymentMethods = async () => {
        const payload = { ...this.state.form, withoutPaginate: true };

        try {
            const res = await Payment.getPaymentMethods(payload);

            const methods = res?.data?.methods ?? res?.methods ?? [];

            // Mapea al formato del select
            const options = methods.map(({ id, name }) => ({ value: id, label: name }));

            this.setState({ paymentMethods: options });
        } catch (error) {
            Globals.showError('Ocurrió un error al obtener los métodos de pago');
            console.log('getPaymentMethods -> catch:', error);
        }
    };

    getClients = async () => {
        Globals.setLoading();

        try {
            const filter = {
                user_id: this.state.form.user_id,
                search: this.state.form.search,
            };

            const res = await axios.post('web/admin/orders/clients', filter);
            if (!res.data?.clients) throw Error('No se encontraron los clientes');

            const clients = res.data.clients.data.map(c => ({
                ...c,
                value: c.id,
                label: !!c.document ? `${c.name} - Rif ${c.document}` : c.name,
            }));

            this.setState({ clients });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('Cuentas por Pagar -> getClients -> catch:', error)
        }

        Globals.quitLoading();
    }

    getSellers = async () => {
        Globals.setLoading();

        try {
            const filter = {
                user_id: this.state.form.user_id,
                include_inactives: true,
            };

            const res = await axios.post('web/admin/orders/sellers', filter);
            if (!res.data?.sellers) throw Error('No se encontraron los vendedores');

            const sellers = res.data.sellers.data.map(c => ({
                ...c,
                value: c.id,
                label: !!c.document ? `${c.name} - Rif ${c.document}` : c.name,
            }));

            this.setState({ sellers });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('Cuentas por Pagar -> getSellers -> catch:', error)
        }

        Globals.quitLoading();
    }

    getZones = async () => {
        Globals.setLoading();

        axios
            .post("web/admin/zones", { user_id: this.props.user.id })
            .then(({ data }) => {
                data.zones.unshift({ id: "", name: "Todas" });
                this.setState({ zones: data.zones.map(item => ({ value: item.id, label: item.name })) });
            })
            .catch(() => Globals.showError())
            .then(() => Globals.quitLoading());
    }

    getOdooDivisions = async () => {
        try {
            const filter = { user_id: this.state.form.user_id };
            const res = await axios.post('admin/accounts-receivable/odoo-divisions', filter);
            const data = Array.isArray(res.data) ? res.data : (res.data?.odoo_divisions || []);
            this.setState({ odoo_divisions: data });
        } catch (error) {
            console.log('Cuentas por Pagar -> getOdooDivisions -> catch:', error);
        }
    }

    warehouses = () => {
        let param = {
            role: this.props.user.role,
            user_id: this.props.user.id
        };
        axios
            .post("admin/products/warehouses", param)
            .then(res => {
                if (res.data.result) {
                    let form = [];
                    res.data.warehouses.forEach((el, i) => {
                        form.push({
                            id: el.id,
                            name: el.name,
                            stock_min: "",
                            stock_max: "",
                            price: "",
                            location: ""
                        });
                    });
                    this.setState({
                        warehouses: form
                    });
                } else {
                    Globals.showError(res.data.msg);
                }
            })
            .catch(err => {
                Globals.showError();
            })
            .then(() => {
                Globals.quitLoading();
            });
    };

    getWarehouses = id => {
        if (!id) {
            let warehouses_filtered = [];
            this.setState(state => ({
                ...state,
                warehouses: warehouses_filtered,
                form: {
                    ...state.form,
                    warehouse_id: ""
                }
            }));
            return;
        }

        let { user } = this.props;

        const enterpriseId = (user.enterprise_users || {}).enterprise_id || user.id;

        Warehouse.getWarehouses({
            role: user.role,
            user_id: enterpriseId,
            branch_id: id
        }).then(response => {
            if (response.result) {
                let warehouses_filtered = [];
                if (user.role === 4) {
                    warehouses_filtered = response.warehouses.data.filter(el => {
                        return user.assigned_warehouses.some(f => {
                            return parseInt(f.warehouse_id) === parseInt(el.id);
                        });
                    });
                } else {
                    warehouses_filtered = response.warehouses.data;
                }

                this.setState(state => ({
                    warehouses: warehouses_filtered,
                    form: {
                        ...state.form,
                        warehouse_id: ""
                    }
                }));
            }
        });
    };

    getSubcategories = categoryId => {
        let param = {
            category_id: categoryId,
            select: true
        };
        Category.getSubcategories(param).then(response => {
            if (response.result) {
                this.setState(state => ({
                    ...state,
                    subcategories: response.subcategories,
                    form: {
                        ...state.form,
                        subcategory_id: ""
                    }
                }));
            }
        });
    };

    getModels = brandId => {
        let param = {
            brand_id: brandId,
            select: true,
            user_id: this.props.user.id
        };
        const { form } = this.state;
        Brand.getModels(param).then(response => {
            if (response.result) {
                this.setState({
                    models: response.models,
                    form: {
                        ...form,
                        model_id: ""
                    }
                });
            }
        });
    };

    openProductsDetails = e => {
        this.change(e);
        if (e.target.value === "")
            this.setState({
                showProductsFilters: false
            });
        else
            this.setState({
                showProductsFilters: true
            });
    };

    change = async (e) => {
        await this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    debouncingSearchClient = async (search) => {
        if (this.debounce.current) clearTimeout(this.debounce.current);

        await this.change({ target: { value: undefined, name: 'client_id' } });
        await this.change({ target: { value: search, name: 'search' } });
        this.debounce.current = setTimeout(async () => {
            this.getClients();
        }, 1000);
    }

    changeTab = async (tab) => {
        await this.setState({
            tab,
            data: [],
            dataClients: [],
            page: 1,
            importSummary: { processed: 0, errors: 0, total: 0 },
            fileToUpload: null
        });

        if (this.state.tab === TAB.CONSOLIDATED) {
            this.getConsolidated();
        } else if (this.state.tab === TAB.INDIVIDUAL) {
            this.getIndividual();
        }
    }

    chooseFileCxC = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const allowedExtensions = ['xlsx', 'xls', 'csv'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!allowedExtensions.includes(fileExtension)) {
                Globals.showError('Formato inválido. Solo se permiten archivos .xlsx, .xls y .csv');
                e.target.value = null;
                return;
            }

            if (file.size > 10 * 1024 * 1024) {
                Globals.showError('El archivo excede el tamaño máximo permitido de 10 MB');
                e.target.value = null;
                return;
            }

            this.setState({ fileToUpload: file });
        }
    }

    processImportCxC = () => {
        const { fileToUpload } = this.state;
        if (!fileToUpload) return;

        Globals.confirm('¿Realmente desea procesar el archivo de cuentas por cobrar?', async () => {
            Globals.setLoading();

            const data = {
                file: fileToUpload,
                user_id: this.props.user.id
            };

            axios
                .upload("admin/accounts-receivable/import-excel", data)
                .then(res => {
                    if (res.data.result) {
                        Globals.showSuccess("Carga de cuentas por cobrar exitosa");
                        this.setState({
                            importSummary: {
                                processed: res.data.processed || 0,
                                errors: res.data.errors || 0,
                                total: (res.data.processed || 0) + (res.data.errors || 0)
                            },
                            fileToUpload: null
                        });
                        const inputElement = document.getElementById('excel-file-cxc');
                        if (inputElement) inputElement.value = "";
                    } else {
                        Globals.showError(res.data.error || 'Ocurrió un error al procesar el archivo');
                    }
                })
                .catch(err => {
                    Globals.showError('Ocurrió un error al subir el archivo');
                })
                .then(() => Globals.quitLoading());
        });
    }

    handleCheck = async e => {
        var { name, checked } = e.target;
        let { form, header, trows } = this.state;

        let sectionPrices = header
            .filter(Item => {
                return Item.section === "price";
            })
            .map(Item => {
                return Item.value;
            });

        let sectionStock = header
            .filter(Item => {
                return Item.section === "stock";
            })
            .map(Item => {
                return Item.value;
            });

        if (trows.length === 0) {
            trows = header.filter(Item => {
                return Item.type === 1;
            });
        } else {
            trows = trows.filter(Item => {
                return Item.type;
            });
        }

        let find = header.find(Item => Item.value === name);

        if (sectionPrices.includes(name)) {
            if (!trows.find(Item => Item.value === find.value)) {
                let countSecPrice = trows.filter(Item => {
                    return Item.section === "price";
                });

                trows.push(find);

                if (countSecPrice.length === 0) {
                    let totalRow = header.find(Item => Item.value === "total");
                    totalRow.multiplier = name;
                    trows.push(totalRow);
                } else {
                    let indexRow = trows.findIndex(Item => Item.value === "total");
                    if (indexRow > -1) {
                        trows.splice(indexRow, 1);
                    }
                }
            } else {
                let index2 = trows.findIndex(Item => Item.value === name);
                trows.splice(index2, 1);

                let countSecPrice = trows.filter(Item => {
                    return Item.section === "price";
                });

                if (countSecPrice.length === 1) {
                    let totalRow = header.find(Item => Item.value === "total");
                    totalRow.multiplier = countSecPrice[0].value;
                    trows.push(totalRow);
                } else {
                    let indexRow = trows.findIndex(Item => Item.value === "total");
                    if (indexRow > -1) {
                        trows.splice(indexRow, 1);
                    }
                }
            }
        }

        if (sectionStock.includes(name)) {
            if (!trows.find(Item => Item.value === find.value)) {
                let countSecStock = trows.filter(Item => {
                    return Item.section === "stock";
                });

                trows.push(find);

                if (countSecStock.length === 0) {
                    let totalAvailable = header.find(Item => Item.value === "available");
                    trows.push(totalAvailable);
                } else {
                    let indexRow = trows.findIndex(Item => Item.value === "available");
                    if (indexRow > -1) {
                        trows.splice(indexRow, 1);
                    }
                }
            } else {
                let index2 = trows.findIndex(Item => Item.value === name);
                trows.splice(index2, 1);

                let countSecStock = trows.filter(Item => {
                    return Item.section === "stock";
                });

                if (countSecStock.length === 1) {
                    let totalAvailable = header.find(Item => Item.value === "available");
                    trows.push(totalAvailable);
                } else {
                    let indexRow = trows.findIndex(Item => Item.value === "available");
                    if (indexRow > -1) {
                        trows.splice(indexRow, 1);
                    }
                }
            }
        }

        trows.sort((a, b) => parseInt(a.order) - parseInt(b.order));

        let thead = trows.map(Item => {
            return Item.label;
        });

        this.setState({
            form: {
                ...form,
                [name]: checked
            }
        });

        this.getThead(thead, trows);
        return;
    };

    getThead = async (arr = [], arr2 = []) => {
        const { header } = this.state;

        let newHeader = arr;

        if (newHeader.length === 0) {
            newHeader = header
                .filter(Item => {
                    return Item.type === 1;
                })
                .map(Item => {
                    return Item.label;
                });
        }

        await this.setState(state => {
            state.thead = newHeader;
            state.trows = arr2;
        });
    };

    returnState = async () => {
        await this.setState(state => ({
            ...state,
            page: 1,
            search: '',
            form: {
                status: "",
                search: "",
                branch_id: "",
                warehouse_id: "",
                category_id: "",
                subcategory_id: "",
                brand_id: "",
                model_id: "",
                user_id: "",
                order_id: "",
                payment_method_id: "",
                since: "",
                until: "",
                client_id: "",
                seller_id: "",
                zone_id: "",
                is_expired: "",
                odoo_division_id: "",
            },
            thead: [],
            trows: [],
            optionals: [
                { value: "code", label: "Código", show: true },
                { value: "name", label: "Nombre", show: true },
                { value: "branch", label: "Almacen", show: true },
                { value: "warehouse", label: "Almacen", show: true },
                { value: "current_stock", label: "Existencia", show: true },
                //{ value: "committed", label: "Comprometido", show: false },
                { value: "available", label: "Disponible", show: true },
                { value: "total", label: "Total", show: true },
                //{ value: "cost", label: "Costo", show: false },
                //{ value: "price", label: "Precio Min.", show: false },
                //{ value: "price_max", label: "Precio Max.", show: false },
                //{ value: "price_offer", label: "Precio Oferta", show: false }
            ],
        }));
        await this.getThead();
        await this.load();
    };

    print = () => {
        Globals.typeDownloadOptions(
            `Selecciona en que formato deseas que se exporte el reporte`,
            (type_download) => {
                Globals.yesOrNo(
                    `¿Desea que se vean los comprobantes de los pagos?`,
                    (with_receipts) => {
                        Globals.setLoading();
                        const payload = {
                            ...this.state.form,
                            currency: Constants.CURRENCIES.DOLARES,
                            type_download: type_download,
                            with_receipts: with_receipts ? 1 : 0,
                        };
                        axios
                            .post("admin/reports/accounts-receivable/download", payload)
                            .then(res => {
                                if (res.data.url_storage) {
                                    const url = `${ENV.BasePublic}${res.data.url_storage}`;
                                    const win = window.open(url, "_blank");
                                    if (win) win.focus();
                                }
                                else {
                                    Globals.showError('Ha ocurrido un error');
                                }
                            })
                            .catch(err => {
                                Globals.showError();
                            })
                            .then(() => Globals.quitLoading());
                    }
                );
            }
        );

    };

    printConsolidated = () => {
        let { form } = this.state;
        form.currency = Constants.CURRENCIES.DOLARES;

        Globals.typeDownloadOptions(
            `Selecciona en que formato deseas que se exporte el reporte`,
            (type_download) => {
                Globals.yesOrNo(
                    `¿Desea que se vean los comprobantes de los pagos?`,
                    (with_receipts) => {
                        Globals.setLoading();
                        const payload = {
                            ...this.state.form,
                            type_download: type_download,
                            download: true,
                            with_receipts: with_receipts ? 1 : 0,
                        };

                        axios
                            .post("admin/accounts-receivable/consolidated", payload)
                            .then(res => {
                                if (res.data.url_storage) {
                                    const url = `${ENV.BasePublic}${res.data.url_storage}`;
                                    const win = window.open(url, "_blank");
                                    if (win) win.focus();
                                }
                                else {
                                    Globals.showError('Ha ocurrido un error');
                                }
                            })
                            .catch(err => {
                                Globals.showError();
                            })
                            .then(() => Globals.quitLoading());
                    }
                );
            }
        );
    };

    close = (reload = false) => {
        this.setState({ modalPaymentDetails: false, modalAddPayment: false, selectedItem: null, modalAddPaymentMultiple: false });
        if (reload) this.load(this.state.page);
    }

    viewPayments = (item) => {
        console.log(item)
        this.setState({ modalPaymentDetails: true, selectedItem: item });
    }

    addPayment = (item) => {
        this.setState({ modalAddPayment: true, selectedItem: item });
    }

    addPaymentMultiple = (item) => {
        console.log(item)

        // Verificar si existe al menos un pago con admin_confirmation igual a 0
        const hasUnconfirmedPayment = item.orders.some(order =>
            order.payments.some(payment => payment.admin_confirmation === 0)
        );
        if (hasUnconfirmedPayment) {
            Globals.showError("No se puede registrar un abono múltiple a esta cuenta, debido a que tiene abonos pendientes por aprobar.");
            return;
        }

        this.setState({ modalAddPaymentMultiple: true, selectedItem: item });
    }

    approve = (item) => {
        const data = {
            order_id: item.order_id,
            payment_id: item.id,
            user_id: this.props.user.id,
        };

        Globals.confirm('¿Realmente desea aprobar este pago?', async () => {
            try {
                const res = await axios.post('admin/accounts-receivable/approve', data);
                if (!res.data?.result) throw new Error('Ocurrió un error inesperado');
                Globals.showSuccess('Pago aprobado con éxito');
                this.close(true);

            } catch (error) {
                Globals.showError(error?.message);
                console.log('Payments -> approve -> catch: ', error);
            }
        });
    }

    reject = (item) => {
        const data = {
            order_id: item.order_id,
            payment_id: item.id,
            user_id: this.props.user.id,
        };

        Globals.confirm('¿Realmente desea rechazar este pago?', async () => {
            try {
                const res = await axios.post('admin/accounts-receivable/reject', data);
                if (!res.data?.result) throw new Error('Ocurrió un error inesperado');
                Globals.showSuccess('Pago rechazado con éxito');
                this.close(true);

            } catch (error) {
                Globals.showError(error?.message);
                console.log('Payments -> reject -> catch: ', error);
            }
        });
    }

    delete = async (item) => {
        console.log(item)
        Globals.setLoading();

        try {
            const data = {
                web: true,
                user_id: this.props.user.id,
                payment_id: item.id,
            };

            await axios.post('admin/accounts-receivable/delete', data);
            Globals.showSuccess("Se ha eliminado el pago correctamente");
            this.close(true)

        } catch (error) {
            Globals.showError();
            console.log('Commissions -> load -> catch: ', error);
        }

        Globals.quitLoading();
    }

    printOrderPdf = (orderId) => {
        Globals.yesOrNo(
            `¿Desea que se vean los comprobantes de los pagos?`,
            (with_receipts) => {
                Globals.setLoading();
                axios
                    .post('admin/accounts-receivable/print-orders', {
                        order_ids: [orderId],
                        user_id: this.props.user.id,
                        with_receipts: with_receipts ? 1 : 0,
                    })
                    .then(res => {
                        if (res.data.url_storage) {
                            const url = `${ENV.BasePublic}${res.data.url_storage}`;
                            const win = window.open(url, '_blank');
                            if (win) win.focus();
                        } else {
                            Globals.showError('Ha ocurrido un error al generar el PDF');
                        }
                    })
                    .catch(() => Globals.showError())
                    .then(() => Globals.quitLoading());
            }
        );
    }

    printClientPdf = (client) => {
        const orders = client?.orders_filter?.length > 0 ? client.orders_filter : (client?.orders || []);
        const ids = orders.map(o => o.id);
        if (!ids.length) return;

        Globals.yesOrNo(
            `¿Desea que se vean los comprobantes de los pagos?`,
            (with_receipts) => {
                Globals.setLoading();
                axios
                    .post('admin/accounts-receivable/print-orders', {
                        order_ids: ids,
                        user_id: this.props.user.id,
                        with_receipts: with_receipts ? 1 : 0,
                    })
                    .then(res => {
                        if (res.data.url_storage) {
                            const url = `${ENV.BasePublic}${res.data.url_storage}`;
                            const win = window.open(url, '_blank');
                            if (win) win.focus();
                        } else {
                            Globals.showError('Ha ocurrido un error al generar el PDF');
                        }
                    })
                    .catch(() => Globals.showError())
                    .then(() => Globals.quitLoading());
            }
        );
    }

    getStatusName = (status) => {
        switch (status) {
            case Constants.PAYMENT_ADMIN_CONFIRM.PENDING:
                return 'Pendiente por aprobación';
            case Constants.PAYMENT_ADMIN_CONFIRM.REJECTED:
                return 'Rechazado';
            case Constants.PAYMENT_ADMIN_CONFIRM.APPROVED:
            default:
                return 'Aprobado';
        }
    }

    getStatusColor = (status) => {
        switch (status) {
            case Constants.PAYMENT_ADMIN_CONFIRM.PENDING:
                return '#3A7FC2';
            case Constants.PAYMENT_ADMIN_CONFIRM.REJECTED:
                return '#DD4B4B';
            case Constants.PAYMENT_ADMIN_CONFIRM.APPROVED:
            default:
                return '#38CE6A';
        }
    }

    render() {
        const { tab, trows } = this.state;
        const showTotal = trows.find(i => i.value === 'total') && trows.find(i => i.value === 'cost');
        const {
            total_pedidos,
            total_abonado,
            total_cobrar,
            modalPaymentDetails,
            modalAddPayment,
            modalAddPaymentMultiple,
            selectedItem,
            paymentMethods,
            showPhoto,
            showFilters,
        } = this.state;
        const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);

        return (
            <Menu
                history={this.props.history}
                hideContentBreadcumbs
                leftSlot={null}
                rightSlot={null}
            >
                {/* ---------- KEEP EXISTING MODALS ---------- */}
                {!!showPhoto && (
                    <div className="modal-planner-view-photo" style={{ zIndex: 2050 }}>
                        <div className="close-photo" onClick={() => this.setState({ showPhoto: null })}>
                            <img src={CloseBlackIcon} alt="Cerrar" />
                        </div>
                        <div className="photo-wrapper">
                            <img src={Globals.fromPhotos(showPhoto)} alt="" />
                        </div>
                    </div>
                )}

                {modalPaymentDetails && (
                    <Modal title="Pagos Realizados" onClose={() => this.close()} visible>
                        {
                            selectedItem?.payments?.map((item) => (
                                <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid lightgray' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <span style={{ marginRight: 5 }}><b>Pago:</b> </span>
                                        <span>{Globals.formatMiles(item.amount, true)}</span>
                                    </div>
                                    {
                                        item?.method && (
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <span style={{ marginRight: 5 }}><b>Método:</b> </span>
                                                <span>{item.method?.name}</span>
                                            </div>
                                        )
                                    }
                                    {
                                        item?.comments && (
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <span style={{ marginRight: 5 }}><b>Comentarios:</b> </span>
                                                <span>{item.comments}</span>
                                            </div>
                                        )
                                    }
                                    {
                                        item.registered_by && (
                                            <span style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                <span style={{ marginRight: 5 }}><b>Vendedor/Cobrador: </b></span>
                                                <span>{item?.author?.name}</span>
                                            </span>
                                        )
                                    }
                                    <div style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <span style={{ marginRight: 5 }}><b>Estatus: </b></span>
                                        <span style={{ color: this.getStatusColor(item.admin_confirmation) }}>
                                            {this.getStatusName(item.admin_confirmation)}
                                        </span>
                                    </div>
                                    {item.admin_confirmation === Constants.PAYMENT_ADMIN_CONFIRM.APPROVED && (item.approved_by || item.approve_by) && (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <span style={{ marginRight: 5 }}><b>Aprobado por: </b></span>
                                            <span>{item?.approved_by?.name || `Usuario #${item.approve_by}`}</span>
                                        </div>
                                    )}
                                    {item.admin_confirmation === Constants.PAYMENT_ADMIN_CONFIRM.REJECTED && (item.rejected_by || item.reject_by) && (
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <span style={{ marginRight: 5 }}><b>Rechazado por: </b></span>
                                            <span>{item?.rejected_by?.name || `Usuario #${item.reject_by}`}</span>
                                        </div>
                                    )}
                                    {!!item?.photo && (
                                        <div onClick={() => this.setState({ showPhoto: item.photo })}>
                                            <img src={Globals.fromPhotos(item.photo)} style={{ width: 100, height: 100, objectFit: 'contain', cursor: 'pointer' }} alt="" />
                                        </div>
                                    )}
                                    <span>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</span>
                                    {this.props.user.level_id === Constants.ROLE_ADMIN && (
                                        <div style={{ display: 'grid', gridAutoFlow: 'column', direction: 'rtl', gridTemplateColumns: 'repeat(3, 1fr)', flexDirection: 'row-reverse', marginTop: 8, justifyContent: 'space-around', textAlign: 'center' }}>
                                            <div
                                                style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.REJECTED) }}
                                                onClick={() => this.delete(item)}
                                            >
                                                ELIMINAR
                                            </div>
                                            {item.admin_confirmation === Constants.PAYMENT_ADMIN_CONFIRM.PENDING && (
                                                <>
                                                    <div
                                                        style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.REJECTED) }}
                                                        onClick={() => this.reject(item)}
                                                    >
                                                        RECHAZAR
                                                    </div>
                                                    <div
                                                        style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.APPROVED) }}
                                                        onClick={() => this.approve(item)}
                                                    >
                                                        APROBAR
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {this.props.user.level_id === Constants.ROLE_MODERATOR && this.props.user.permissions.length > 0 &&
                                        this.props.user.permissions.some(permission =>
                                            permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_ACCEPT_PAYMENT ||
                                            permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_DELETE_PAYMENT ||
                                            permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_REJECT_PAYMENT
                                        ) && (
                                            <div style={{
                                                display: 'grid',
                                                gridAutoFlow: 'column',
                                                direction: 'rtl',
                                                gridTemplateColumns: 'repeat(3, 1fr)',
                                                flexDirection: 'row-reverse',
                                                marginTop: 8,
                                                justifyContent: 'space-around',
                                                textAlign: 'center'
                                            }}>
                                                {this.props.user.permissions.some(permission => permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_DELETE_PAYMENT) && (
                                                    <div
                                                        style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.REJECTED) }}
                                                        onClick={() => this.delete(item)}
                                                    >
                                                        ELIMINAR
                                                    </div>
                                                )}

                                                {item.admin_confirmation === Constants.PAYMENT_ADMIN_CONFIRM.PENDING && (
                                                    <>
                                                        {this.props.user.permissions.some(permission => permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_REJECT_PAYMENT) && (
                                                            <div
                                                                style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.REJECTED) }}
                                                                onClick={() => this.reject(item)}
                                                            >
                                                                RECHAZAR
                                                            </div>
                                                        )}
                                                        {this.props.user.permissions.some(permission => permission.code === Constants.PERMISSIONS.MODERATOR.ORDERS_ACCEPT_PAYMENT) && (
                                                            <div
                                                                style={{ flex: 1, cursor: 'pointer', color: this.getStatusColor(Constants.PAYMENT_ADMIN_CONFIRM.APPROVED) }}
                                                                onClick={() => this.approve(item)}
                                                            >
                                                                APROBAR
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )
                                    }

                                </div>
                            ))
                        }

                        {
                            !selectedItem?.payments?.length && (
                                <p style={{ padding: 10, textAlign: 'center' }}>No se han registrado pagos</p>
                            )
                        }

                        <Button block secondary onClick={() => this.close()}>
                            <span>CERRAR</span>
                        </Button>
                    </Modal>
                )}

                {modalAddPayment && (
                    <Modal title="Agregar Pago" onClose={() => this.close()} visible>
                        <CreatePayment
                            order={selectedItem}
                            client={null}
                            type={Constants.PAYMENT_INDIVIDUAL}
                            paymentMethods={paymentMethods}
                            onClose={this.close}
                        />
                    </Modal>
                )}

                {modalAddPaymentMultiple && (
                    <Modal title="Agregar Pago Múltiple" onClose={() => this.close()} visible>
                        <CreatePayment
                            order={selectedItem}
                            client={selectedItem}
                            type={Constants.PAYMENT_MULTIPLE}
                            paymentMethods={paymentMethods}
                            onClose={this.close}
                        />
                    </Modal>
                )}

                {/* FILTERS MODAL FROM MOCKUP */}
                <Filters
                    show={showFilters}
                    form={this.state.form}
                    clients={this.state.clients}
                    paymentMethods={this.state.paymentMethods}
                    paymentStatuses={this.state.status_payments}
                    sellers={this.state.sellers}
                    minDate={this.state.dates.minDate}
                    maxDate={this.state.dates.maxDate}
                    optionals={this.state.optionals}
                    handleCheck={this.handleCheck}
                    debouncingSearchClient={this.debouncingSearchClient}
                    odooDivisions={this.state.odoo_divisions ? this.state.odoo_divisions.map(d => ({ value: d.id, label: d.name })) : []}
                    user={this.props.user}
                    onSearch={async (filters) => {
                        await this.setState(s => ({ showFilters: false, page: 1, form: { ...s.form, ...filters } }));
                        this.load();
                    }}
                    onClose={() => this.setState({ showFilters: false })}
                />

                {/* ---------- NEW UI MOCKUP BEGIN ---------- */}
                <div className="cxc-page">
                    <div className="cxc-topbar">
                        <div>
                            <h1 className="cxc-h1">Cuentas por Cobrar</h1>
                            <p className="cxc-subtitle">Gestiona y controla los cobros pendientes de tus clientes.</p>
                        </div>
                    </div>

                    <div className="cxc-tabs">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.changeTab(TAB.CONSOLIDATED); }} className={`cxc-tab ${tab === TAB.CONSOLIDATED ? 'active' : ''}`}>Consolidado</a>
                        <a href="#" onClick={(e) => { e.preventDefault(); this.changeTab(TAB.INDIVIDUAL); }} className={`cxc-tab ${tab === TAB.INDIVIDUAL ? 'active' : ''}`}>Individual</a>
                        <a href="#" onClick={(e) => { e.preventDefault(); this.changeTab(TAB.IMPORT); }} className={`cxc-tab ${tab === TAB.IMPORT ? 'active' : ''}`}>Importar Cuentas por Cobrar</a>
                    </div>

                    {/* ONLY SHOW STATS ON CONSOLIDADO & INDIVIDUAL */}
                    {tab !== TAB.IMPORT && (
                        <div className={`cxc-stats ${tab === TAB.INDIVIDUAL ? 'three' : ''}`}>
                            <div className="cxc-card">
                                <div className="cxc-card-icon cxc-purple">
                                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="cxc-card-label">Total Pedidos</div>
                                    <div className="cxc-card-value">${Globals.formatMiles(total_pedidos)}</div>
                                </div>
                            </div>
                            <div className="cxc-card">
                                <div className="cxc-card-icon cxc-blue">
                                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="cxc-card-label">Total Abonado</div>
                                    <div className="cxc-card-value">${Globals.formatMiles(total_abonado)}</div>
                                </div>
                            </div>
                            <div className="cxc-card">
                                <div className="cxc-card-icon cxc-orange">
                                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="cxc-card-label">Total por Cobrar</div>
                                    <div className="cxc-card-value">${Globals.formatMiles(total_cobrar)}</div>
                                </div>
                            </div>
                            {tab === TAB.CONSOLIDATED && (
                                <div className="cxc-card">
                                    <div className="cxc-card-icon cxc-cyan">
                                        <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="cxc-card-label">Clientes deudores</div>
                                        <div className="cxc-card-value">{this.state.dataClients.length}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {tab === TAB.CONSOLIDATED && (
                        <div className="cxc-table-panel">
                            <div className="cxc-toolbar">
                                <div className="cxc-search">
                                    {/* <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>
                                    <input 
                                        type="text" 
                                        placeholder="Buscar por Nombre del Cliente o Rif" 
                                        value={this.state.form.search}
                                        onChange={(e) => this.setState({ form: { ...this.state.form, search: e.target.value }})}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                this.setState({ page: 1 }, () => this.load());
                                            }
                                        }}
                                    /> */}
                                </div>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <button className="cxc-filter-btn" onClick={() => this.setState({ showFilters: true })}>
                                        <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" /></svg>
                                        Filtros
                                    </button>
                                    <button className="cxc-print-btn" onClick={this.printConsolidated} title="Imprimir">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: 18, height: 18 }}><path d="M7 8V4h10v4" /><rect x="5" y="13" width="14" height="7" /><path d="M5 16H3V9h18v7h-2" /></svg>
                                    </button>
                                </div>
                            </div>

                            <div className="cxc-table-wrap">
                                <table className="cxc-table">
                                    <thead>
                                        <tr>
                                            <th className="cxc-th">ID</th>
                                            <th className="cxc-th">Fecha de emisión</th>
                                            <th className="cxc-th">Fecha de vencimiento</th>
                                            <th className="cxc-th">Días vencido</th>
                                            <th className="cxc-th">Estatus pago</th>
                                            <th className="cxc-th">Zona</th>
                                            {isOdooUser && <th className="cxc-th">División</th>}
                                            <th className="cxc-th" style={{ textAlign: 'right' }}>Saldo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dataClients.map((clientId, clientIndex) => {
                                            const client = this.state.data.find(x => x.id === clientId);
                                            const total = client?.orders_filter?.length > 0 ? client.orders_filter.map(x => x.to_pay).reduce((acc, curr) => acc + curr, 0) : client?.orders?.map(x => x.to_pay).reduce((acc, curr) => acc + curr, 0);
                                            const orders = client?.orders_filter?.length > 0 ? client.orders_filter : (client?.orders || []);

                                            const colorClasses = ['cxc-group-purple', 'cxc-group-blue', 'cxc-group-green', 'cxc-group-light', 'cxc-group-yellow'];
                                            const avatarClasses = ['cxc-av-purple', 'cxc-av-blue', 'cxc-av-green', 'cxc-av-cyan', 'cxc-av-yellow'];
                                            const groupClass = colorClasses[clientIndex % colorClasses.length];
                                            const avatarClass = avatarClasses[clientIndex % avatarClasses.length];
                                            const initial = client?.name ? client.name.charAt(0).toUpperCase() : 'C';
                                            const isCollapsed = this.state.collapsedClients[clientId];
                                            const allPaid = orders.length > 0 && orders.every(o => o.status_payment === 4 || o.status_payment_expired_text?.toLowerCase().includes('pagada'));

                                            return (
                                                <React.Fragment key={clientId}>
                                                    <tr className={groupClass}>
                                                        <td colSpan={isOdooUser ? "7" : "6"} className="cxc-td">
                                                            <div className="cxc-client-cell" onClick={() => this.toggleClient(clientId)} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                                                <div className="cxc-arrow" style={{ transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>
                                                                </div>
                                                                <div className={`cxc-avatar ${avatarClass}`}>{initial}</div>
                                                                <div>
                                                                    <div className="cxc-client-name">{client?.name} {client?.document ? client.document : ''}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="cxc-td" style={{ textAlign: 'right' }}>
                                                            <div className="cxc-saldo-cell">
                                                                <span className="cxc-amount">${Globals.formatMiles(total, true)}</span>
                                                                <div className="cxc-wallet" onClick={() => this.printClientPdf(client)} title="Imprimir PDF">
                                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M7 8V4h10v4" /><rect x="5" y="13" width="14" height="7" /><path strokeLinecap="round" strokeLinejoin="round" d="M5 16H3V9h18v7h-2" /></svg>
                                                                </div>
                                                                {!allPaid && (
                                                                    <div className="cxc-wallet" onClick={() => this.addPaymentMultiple(client)} title="Agregar pago múltiple">
                                                                        <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" /></svg>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    {!isCollapsed && orders.map((i, index) => {
                                                        const expireDate = moment(i.created_at).add(i.credit_days || 0, 'days');
                                                        const isExpired = moment() >= expireDate;
                                                        return (
                                                            <tr className={`cxc-subrow ${groupClass}`} key={i.id || index}>
                                                                <td className="cxc-td" style={{ paddingLeft: '56px' }}>{i.correlative_number}</td>
                                                                <td className="cxc-td">{moment(i.created_at).format('DD/MM/YYYY')}</td>
                                                                <td className="cxc-td">{moment(i.created_at).add(i.credit_days || 0, 'days').format('DD/MM/YYYY')}</td>
                                                                <td className="cxc-td">{i.credit_days || '-'}</td>
                                                                <td className="cxc-td">
                                                                    <span className={`cxc-status ${i.status_payment_expired_text?.toLowerCase().includes('pagada') ? 'ok' : (isExpired ? 'overdue' : 'ok')}`}>
                                                                        {i.status_payment_expired_text || (isExpired ? 'Vencido' : 'Solvente')}
                                                                    </span>
                                                                </td>
                                                                <td className="cxc-td">{i.zone?.name || ''}</td>
                                                                {isOdooUser && <td className="cxc-td">{i.odoo_division?.name || '-'}</td>}
                                                                <td className="cxc-td" style={{ textAlign: 'right', fontWeight: '600' }}>
                                                                    ${parseFloat(Number(i.to_pay)).toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            <div className="cxc-footer">
                                <div>Mostrando {this.state.data.length} de {this.state.total_count || this.state.data.length} pedidos</div>
                                {this.renderPagination()}
                            </div>
                        </div>
                    )}

                    {tab === TAB.INDIVIDUAL && (
                        <div className="cxc-table-panel">
                            <div className="cxc-toolbar">
                                <div className="cxc-search">
                                    {/* <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>
                                    <input
                                        type="text"
                                        placeholder="Buscar por Nombre del Cliente o Rif"
                                        value={this.state.form.search}
                                        onChange={(e) => this.setState({ form: { ...this.state.form, search: e.target.value } })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                this.setState({ page: 1 }, () => this.load());
                                            }
                                        }}
                                    /> */}
                                </div>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <button className="cxc-filter-btn" onClick={() => this.setState({ showFilters: true })}>
                                        <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" /></svg>
                                        Filtros
                                    </button>
                                    <button className="cxc-print-btn" onClick={this.print} title="Imprimir">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: 18, height: 18 }}><path d="M7 8V4h10v4" /><rect x="5" y="13" width="14" height="7" /><path d="M5 16H3V9h18v7h-2" /></svg>
                                    </button>
                                </div>
                            </div>

                            <div className="cxc-table-wrap">
                                <table className="cxc-table">
                                    <thead>
                                        <tr>
                                            <th className="cxc-th">ID</th>
                                            <th className="cxc-th">Fecha Emisión</th>
                                            <th className="cxc-th">Fecha Despacho</th>
                                            <th className="cxc-th">Vendedor</th>
                                            <th className="cxc-th">Cliente</th>
                                            <th className="cxc-th">Estatus Pago</th>
                                            <th className="cxc-th">Zona</th>
                                            {isOdooUser && <th className="cxc-th">División</th>}
                                            <th className="cxc-th" style={{ textAlign: 'right' }}>Total Deuda</th>
                                            <th className="cxc-th" style={{ textAlign: 'right' }}>Por Cobrar</th>
                                            <th className="cxc-th"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.map((i, index) => {
                                            const expireDate = moment(i.created_at).add(i.credit_days || 0, 'days');
                                            const isExpired = moment() >= expireDate;
                                            const initial = i.client?.name ? i.client.name.charAt(0).toUpperCase() : 'C';
                                            const vInitial = i.seller?.name ? i.seller.name.charAt(0).toUpperCase() : 'V';
                                            const isPaid = i.status_payment === 4 || i.status_payment_expired_text?.toLowerCase().includes('pagada');

                                            return (
                                                <tr key={index}>
                                                    <td className="cxc-td" style={{ fontWeight: '600' }}>{i.correlative_number}</td>
                                                    <td className="cxc-td">{i.created_es}</td>
                                                    <td className="cxc-td">{i.dispatch_date != null ? moment(i.dispatch_date).format('DD/MM/YYYY') : '-'}</td>
                                                    <td className="cxc-td">
                                                        <div className="cxc-vendor">
                                                            <div className="cxc-avatar cxc-av-cyan">{vInitial}</div>
                                                            <span style={{ fontWeight: '600' }}>{i.seller?.name ?? ''}</span>
                                                        </div>
                                                    </td>
                                                    <td className="cxc-td">
                                                        <div className="cxc-vendor">
                                                            <div className="cxc-avatar cxc-av-light">{initial}</div>
                                                            <div>
                                                                <div className="cxc-client-name">{i.client?.name ?? ''}</div>
                                                                <div className="cxc-client-sub">
                                                                    {[i.client?.rif, i.client?.document].filter(Boolean).join(' - ')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="cxc-td">
                                                        <span className={`cxc-status ${i.status_payment_expired_text?.toLowerCase().includes('pagada') ? 'ok' : (isExpired ? 'overdue' : 'ok')}`}>
                                                            {i.status_payment_expired_text || (isExpired ? 'Vencido' : 'Solvente')}
                                                        </span>
                                                    </td>
                                                    <td className="cxc-td">{i.zone?.name || ''}</td>
                                                    {isOdooUser && <td className="cxc-td">{i.odoo_division?.name || '-'}</td>}
                                                    <td className="cxc-td" style={{ textAlign: 'right' }}>${parseFloat(Number(i.total)).toFixed(2)}</td>
                                                    <td className="cxc-td" style={{ textAlign: 'right', fontWeight: '700' }}>${parseFloat(Number(i.to_pay)).toFixed(2)}</td>
                                                    <td className="cxc-td">
                                                        <div className="cxc-actions">
                                                            <button className="cxc-action-btn view" title="Ver pagos" onClick={() => this.viewPayments(i)}>
                                                                <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                                            </button>
                                                            {!isPaid && (
                                                                <button className="cxc-action-btn download" title="Agregar pago" onClick={() => this.addPayment(i)}>
                                                                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                                                </button>
                                                            )}
                                                            <button className="cxc-action-btn print" title="Imprimir PDF" onClick={() => this.printOrderPdf(i.id)}>
                                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M7 8V4h10v4" /><rect x="5" y="13" width="14" height="7" /><path strokeLinecap="round" strokeLinejoin="round" d="M5 16H3V9h18v7h-2" /></svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            <div className="cxc-footer">
                                <div>Mostrando {this.state.data.length} de {this.state.total_count || this.state.data.length} pedidos</div>
                                {this.renderPagination()}
                            </div>
                        </div>
                    )}

                    {tab === TAB.IMPORT && (
                        <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '10px', marginTop: '20px' }}>
                            <div style={{ marginBottom: '1rem' }}>
                                <h4 style={{ color: '#102d4f', fontWeight: 'bold' }}>Cuentas por Cobrar</h4>
                                <p style={{ color: '#6c757d' }}>Gestiona y controla los cobros pendientes de tus clientes.</p>
                            </div>

                            <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                                <div
                                    style={{
                                        flex: 1,
                                        minWidth: '300px',
                                        border: `2px dashed ${this.state.isDragging ? '#0d6efd' : '#3a7fc2'}`,
                                        borderRadius: '10px',
                                        padding: '2rem',
                                        textAlign: 'center',
                                        backgroundColor: this.state.isDragging ? '#e9f2ff' : '#f8f9fa'
                                    }}
                                    onDragEnter={this.handleDrag}
                                    onDragLeave={this.handleDrag}
                                    onDragOver={this.handleDrag}
                                    onDrop={this.handleDrop}
                                >
                                    <img src={UploadIcon} alt="Upload" style={{ width: 48, marginBottom: '1rem' }} />
                                    <p style={{ fontWeight: 'bold', fontSize: '18px', color: '#102d4f', margin: '10px 0 5px 0' }}>Arrastra y suelta tu archivo aquí</p>
                                    <p style={{ color: '#3a7fc2', fontSize: '14px', marginBottom: '20px' }}>o selecciona un archivo desde tu dispositivo</p>
                                    <p style={{ color: '#6c757d', fontSize: '12px', marginBottom: '5px' }}>Formatos permitidos: .xlsx, .xls, .csv</p>
                                    <p style={{ color: '#6c757d', fontSize: '12px', marginBottom: '20px' }}>Tamaño máximo: 10 MB</p>

                                    {this.state.fileToUpload && (
                                        <p style={{ color: 'green', fontSize: '14px', marginBottom: '10px' }}>
                                            Archivo seleccionado: {this.state.fileToUpload.name}
                                        </p>
                                    )}

                                    <label className="btn btn-primary" style={{ backgroundColor: '#0d6efd', color: 'white', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }} htmlFor="excel-file-cxc">
                                        Seleccionar archivo
                                    </label>
                                    <input
                                        id="excel-file-cxc"
                                        type="file"
                                        accept=".xlsx, .xls, .csv"
                                        onChange={this.chooseFileCxC}
                                        style={{ display: 'none' }}
                                    />
                                </div>

                                <div style={{ flex: 1, minWidth: '300px', border: '1px solid #e9ecef', borderRadius: '10px', padding: '2rem', backgroundColor: 'white' }}>
                                    <p style={{ fontWeight: 'bold', color: '#102d4f', marginBottom: '20px' }}>Resumen de la importación</p>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                                        <span style={{ color: '#6c757d' }}> <img src={CheckIcon} style={{ width: 20, marginRight: 5 }} alt="check" /> Registros procesados</span>
                                        <span style={{ fontWeight: 'bold', color: '#102d4f' }}>{this.state.importSummary.processed}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                                        <span style={{ color: '#6c757d' }}> <img src={ErrorIcon} style={{ width: 20, marginRight: 5 }} alt="error" /> Registros con errores</span>
                                        <span style={{ fontWeight: 'bold', color: '#102d4f' }}>{this.state.importSummary.errors}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px', borderTop: '1px solid #e9ecef', paddingTop: '15px' }}>
                                        <span style={{ fontWeight: 'bold', color: '#102d4f', fontSize: '16px' }}> Total Registros Importados</span>
                                        <span style={{ fontWeight: 'bold', color: '#102d4f', fontSize: '18px' }}>
                                            {this.state.importSummary.processed > 0 || this.state.importSummary.errors > 0 ? (this.state.importSummary.processed + this.state.importSummary.errors) : '00'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                                <Button disabled={!this.state.fileToUpload} color={this.state.fileToUpload ? 'blue' : ' '} onClick={this.processImportCxC}>
                                    <span className={this.state.fileToUpload ? 'text-white' : ''}>Procesar archivo</span>
                                </Button>
                            </div>

                            <div style={{ marginTop: '40px', border: '1px solid #e9ecef', borderRadius: '10px', padding: '2rem', backgroundColor: 'white' }}>
                                <p style={{ fontWeight: 'bold', color: '#102d4f', fontSize: '16px', marginBottom: '15px' }}>Guía del archivo de importación</p>
                                <div style={{ backgroundColor: '#f1f5fa', color: '#3a7fc2', padding: '15px', borderRadius: '5px', marginBottom: '20px', fontSize: '14px' }}>
                                    Tu archivo debe cumplir con la estructura y formato indicados para una importación exitosa.
                                </div>

                                <p style={{ fontWeight: 'bold', color: '#102d4f', marginBottom: '15px' }}>Encabezados requeridos</p>

                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', fontSize: '14px', color: '#6c757d', textAlign: 'left', minWidth: '600px' }}>
                                        <thead>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <th style={{ padding: '10px', color: '#102d4f' }}>Campo</th>
                                                <th style={{ padding: '10px', color: '#102d4f' }}>Descripción</th>
                                                <th style={{ padding: '10px', color: '#102d4f' }}>Ejemplo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Num Documento</td>
                                                <td style={{ padding: '10px' }}>Número de la Factura/Nota</td>
                                                <td style={{ padding: '10px' }}>123456 o 000012</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>RIF / Cédula</td>
                                                <td style={{ padding: '10px' }}>RIF o Cédula del Cliente</td>
                                                <td style={{ padding: '10px' }}>J1230000123</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Fecha Emisión</td>
                                                <td style={{ padding: '10px' }}>Fecha de la creación de factura (DD/MM/AAAA)</td>
                                                <td style={{ padding: '10px' }}>00/00/2000</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Fecha Vencimiento</td>
                                                <td style={{ padding: '10px' }}>Fecha Vencimiento de factura (DD/MM/AAAA) (opcional)</td>
                                                <td style={{ padding: '10px' }}>00/00/2000</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Días Vencido</td>
                                                <td style={{ padding: '10px' }}>Cantidad de días transcurridos luego del vencimiento</td>
                                                <td style={{ padding: '10px' }}>10</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Total pedido ($)</td>
                                                <td style={{ padding: '10px' }}>Monto Total Pedido realizado</td>
                                                <td style={{ padding: '10px' }}>100</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Total Abonado ($)</td>
                                                <td style={{ padding: '10px' }}>Total de Abonos realizados a la deuda</td>
                                                <td style={{ padding: '10px' }}>80</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                                                <td style={{ padding: '10px' }}>Zona (ID, nombre o code)</td>
                                                <td style={{ padding: '10px' }}>Identificador, nombre o código de la zona (opcional)</td>
                                                <td style={{ padding: '10px' }}>1 o Centro</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div style={{ marginTop: '20px', borderTop: '1px solid #e9ecef', paddingTop: '20px' }}>
                                    <Button color=" " onClick={() => {
                                        const url = `${ENV.BasePublic}storage/orders/importacion_cXc.xlsx`;
                                        const element = document.createElement('a');
                                        element.href = url;
                                        element.download = 'importacion_cXc.xlsx';
                                        element.target = '_blank';
                                        element.click();
                                    }} style={{ color: '#0d6efd', backgroundColor: 'transparent', border: '1px solid #0d6efd' }}>
                                        <img src={DownloadIcon} style={{ width: 16, marginRight: 5 }} alt="download" /> <span style={{ color: '#0d6efd' }}>Descargar plantilla</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </Menu>
        );
    }

    renderPagination() {
        const { page, last_page } = this.state;
        if (!last_page || last_page <= 1) {
            return (
                <div className="cxc-pagination">
                    <button className="cxc-page-btn" disabled><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14 }}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg></button>
                    <button className="cxc-page-btn active">1</button>
                    <button className="cxc-page-btn" disabled><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14 }}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg></button>
                </div>
            );
        }

        let pages = [];
        for (let i = 1; i <= last_page; i++) {
            if (i === 1 || i === last_page || (i >= page - 1 && i <= page + 1)) {
                pages.push(i);
            } else if (pages[pages.length - 1] !== '...') {
                pages.push('...');
            }
        }

        return (
            <div className="cxc-pagination">
                <button
                    className="cxc-page-btn"
                    disabled={page <= 1}
                    onClick={() => this.load(page - 1)}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14 }}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>
                </button>

                {pages.map((p, index) => {
                    if (p === '...') {
                        return <span key={`ellipsis-${index}`} style={{ display: 'inline-flex', alignItems: 'flex-end', padding: '0 4px', color: '#6c757d', userSelect: 'none' }}>...</span>;
                    }
                    return (
                        <button
                            key={`page-${p}`}
                            className={`cxc-page-btn ${p === page ? 'active' : ''}`}
                            onClick={() => { if (p !== page) this.load(p); }}
                        >
                            {p}
                        </button>
                    )
                })}

                <button
                    className="cxc-page-btn"
                    disabled={page >= last_page}
                    onClick={() => this.load(page + 1)}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14 }}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>
                </button>
            </div>
        );
    }
}

const Filters = ({ show, form, paymentMethods, clients, sellers, paymentStatuses, minDate, maxDate, optionals, handleCheck, onSearch, debouncingSearchClient, onClose, odooDivisions, user }) => {
    const initialFilters = {
        search: '',
        order_id: '',
        client_id: '',
        seller_id: '',
        payment_method_id: '',
        is_expired: '',
        since: '',
        until: '',
        odoo_division_id: '',
    };

    const [_form, setForm] = useState(initialFilters);

    const onChange = (value, target) => {
        setForm(s => ({ ...s, [target]: value }));
    }

    const reset = () => {
        onSearch(initialFilters);
    }

    const fillForm = () => {
        setForm({
            search: form.search ?? '',
            order_id: form.order_id ?? '',
            client_id: form.client_id ?? '',
            seller_id: form.seller_id ?? '',
            payment_method_id: form.payment_method_id ?? '',
            is_expired: form.is_expired ?? '',
            since: !!form.since ? form.since : '',
            until: !!form.until ? form.until : '',
            odoo_division_id: form.odoo_division_id ?? '',
        })
    }

    useEffect(() => {
        fillForm();
    }, [form]);

    if (!show) return null;

    return (
        <div className="cxc-modal-overlay show" onClick={onClose}>
            <div className="cxc-filters-modal" onClick={e => e.stopPropagation()}>
                <div className="cxc-filters-modal-header">
                    <div className="cxc-filters-title-wrap">
                        <div className="cxc-filters-title-icon">
                            <svg fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" /></svg>
                        </div>
                        <div>
                            <h2>Filtros</h2>
                            <p className="cxc-filters-modal-subtitle">Configure los parámetros de búsqueda</p>
                        </div>
                    </div>
                    <button className="cxc-modal-close" onClick={onClose}>&times;</button>
                </div>

                <div className="cxc-filter-section">
                    <h3 className="cxc-filter-section-title">Datos del documento</h3>
                    <div className="cxc-filter-grid two">
                        <div className="cxc-modal-field">
                            <label>ID o Nro de Control</label>
                            <input type="text" className="cxc-modal-control" placeholder="Ej: 1450" value={_form.order_id} onChange={e => onChange(e.target.value, 'order_id')} />
                        </div>
                        <div className="cxc-modal-field">
                            <label>Estatus de pago</label>
                            <select className="cxc-modal-control" value={_form.is_expired} onChange={e => onChange(e.target.value, 'is_expired')}>
                                <option value="">Todos los estatus</option>
                                {paymentStatuses.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="cxc-filter-section">
                    <h3 className="cxc-filter-section-title">Participantes</h3>
                    <div className="cxc-filter-grid two">
                        <div className="cxc-modal-field">
                            <SelectActions
                                label="Cliente"
                                placeholder="Nombre del Cliente o Rif"
                                className="cxc-modal-control select-actions-override"
                                isSearchable
                                options={clients.map(i => ({
                                    value: i.id,
                                    label: i.name,
                                    actions: [],
                                }))}
                                value={_form.client_id}
                                onChange={value => onChange(value, 'client_id')}
                                onInputChange={debouncingSearchClient}
                            />
                        </div>
                        <div className="cxc-modal-field">
                            <label>Vendedor</label>
                            <select className="cxc-modal-control" value={_form.seller_id} onChange={e => onChange(e.target.value, 'seller_id')}>
                                <option value="">Seleccione un vendedor</option>
                                {sellers.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                            </select>
                        </div>
                    </div>
                </div>

                {((user?.admin ? user.admin.odoo : user?.odoo) == 1) && (
                    <div className="cxc-filter-section">
                        <h3 className="cxc-filter-section-title">Divisiones</h3>
                        <div className="cxc-filter-grid two">
                            <div className="cxc-modal-field">
                                <label>División</label>
                                <select className="cxc-modal-control" value={_form.odoo_division_id} onChange={e => onChange(e.target.value, 'odoo_division_id')}>
                                    <option value="">Todas las divisiones</option>
                                    {odooDivisions && odooDivisions.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                )}

                <div className="cxc-filter-section">
                    <h3 className="cxc-filter-section-title">Fecha de Emisión</h3>
                    <div className="cxc-filter-grid two">
                        <div className="cxc-modal-field">
                            <label>Desde</label>
                            <div className="cxc-date-wrap">
                                <input type="date" className="cxc-modal-control" value={_form.since ? moment(_form.since).format('YYYY-MM-DD') : ''} onChange={e => onChange(e.target.value, 'since')} />
                                <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" /></svg>
                            </div>
                        </div>
                        <div className="cxc-modal-field">
                            <label>Hasta</label>
                            <div className="cxc-date-wrap">
                                <input type="date" className="cxc-modal-control" value={_form.until ? moment(_form.until).format('YYYY-MM-DD') : ''} onChange={e => onChange(e.target.value, 'until')} />
                                <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" /></svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cxc-modal-actions">
                    <button className="cxc-modal-action secondary" onClick={reset}>
                        Limpiar todo
                    </button>
                    <button className="cxc-modal-action primary" onClick={() => onSearch(_form)}>
                        Aplicar filtros
                    </button>
                </div>
            </div>
        </div>
    );
}

export default connect(state => {
    return {
        user: state.user
    };
})(Payments);
